

































import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { ContactFormItem } from '../contactFormItem';
import { appService } from '../app.service';

@Component
export default class ContactForm extends Vue {
    contactForm: ContactFormItem = { name: '', email: '', message: '', skills: [] };
    msg: string = "";
    sending: boolean = false;
    submitForm() {
        this.sending = true;
        
        return appService.submitForm(this.contactForm).then(() => {
            this.contactForm = {
                name: '', email: '', message: '', skills: [] };
            this.msg = "Thank you for your interest. Your form has been submitted"

        }).catch(error => {
            console.log(error.response)
        });
    }

}
